import {
  CreateSenderAccountRequest,
  ISenderAccount,
  UpdateSenderAccountRequest,
} from 'types/senderAccounts/senderAccount.types';
import {
  CLEAR_SENDER_ACCOUNT_STATE,
  ClearSenderAccountStateAction,
  CREATE_SENDER_ACCOUNT_FAILURE,
  CREATE_SENDER_ACCOUNT_REQUEST,
  CREATE_SENDER_ACCOUNT_SUCCESS,
  CreateSenderAccountFailureAction,
  CreateSenderAccountRequestAction,
  CreateSenderAccountSuccessAction,
  DELETE_SENDER_ACCOUNT_FAILURE,
  DELETE_SENDER_ACCOUNT_REQUEST,
  DELETE_SENDER_ACCOUNT_SUCCESS,
  DeleteSenderAccountFailureAction,
  DeleteSenderAccountRequestAction,
  DeleteSenderAccountSuccessAction,
  GET_SENDER_ACCOUNT_BY_ID_FAILURE,
  GET_SENDER_ACCOUNT_BY_ID_REQUEST,
  GET_SENDER_ACCOUNT_BY_ID_SUCCESS,
  GetSenderAccountByIdFailureAction,
  GetSenderAccountByIdRequestAction,
  GetSenderAccountByIdSuccessAction,
  GET_VERIFIED_SENDER_ACCOUNTS_REQUEST,
  GET_VERIFIED_SENDER_ACCOUNTS_SUCCESS,
  GET_VERIFIED_SENDER_ACCOUNTS_FAILURE,
  GetVerifiedSenderAccountsRequestAction,
  GetVerifiedSenderAccountsSuccessAction,
  GetVerifiedSenderAccountsFailureAction,
  UPDATE_SENDER_ACCOUNT_FAILURE,
  UpdateSenderAccountFailureAction,
  UPDATE_SENDER_ACCOUNT_REQUEST,
  UPDATE_SENDER_ACCOUNT_SUCCESS,
  UpdateSenderAccountSuccessAction,
  UpdateSenderAccountRequestAction,
} from './senderAccounts.types';

export const createSenderAccountRequest = (
  senderAccount: CreateSenderAccountRequest
): CreateSenderAccountRequestAction => ({
  type: CREATE_SENDER_ACCOUNT_REQUEST,
  payload: senderAccount,
});

export const createSenderAccountSuccess = (
  senderAccount: ISenderAccount
): CreateSenderAccountSuccessAction => ({
  type: CREATE_SENDER_ACCOUNT_SUCCESS,
  payload: senderAccount,
});

export const createSenderAccountFailure = (
  error: string
): CreateSenderAccountFailureAction => ({
  type: CREATE_SENDER_ACCOUNT_FAILURE,
  payload: error,
});

export const updateSenderAccountRequest = (
  senderAccount: UpdateSenderAccountRequest
): UpdateSenderAccountRequestAction => ({
  type: UPDATE_SENDER_ACCOUNT_REQUEST,
  payload: senderAccount,
});

export const updateSenderAccountSuccess = (
  senderAccount: ISenderAccount
): UpdateSenderAccountSuccessAction => ({
  type: UPDATE_SENDER_ACCOUNT_SUCCESS,
  payload: senderAccount,
});

export const updateSenderAccountFailure = (
  error: string
): UpdateSenderAccountFailureAction => ({
  type: UPDATE_SENDER_ACCOUNT_FAILURE,
  payload: error,
});

export const getSenderAccountByIdRequest = (
  id: string
): GetSenderAccountByIdRequestAction => ({
  type: GET_SENDER_ACCOUNT_BY_ID_REQUEST,
  payload: {
    id,
  },
});

export const getSenderAccountByIdSuccess = (
  senderAccount: ISenderAccount
): GetSenderAccountByIdSuccessAction => ({
  type: GET_SENDER_ACCOUNT_BY_ID_SUCCESS,
  payload: senderAccount,
});

export const getSenderAccountByIdFailure = (
  error: string
): GetSenderAccountByIdFailureAction => ({
  type: GET_SENDER_ACCOUNT_BY_ID_FAILURE,
  payload: error,
});

export const deleteSenderAccountRequest = (
  id: string
): DeleteSenderAccountRequestAction => ({
  type: DELETE_SENDER_ACCOUNT_REQUEST,
  payload: {
    id,
  },
});

export const deleteSenderAccountSuccess = (
  id: string
): DeleteSenderAccountSuccessAction => ({
  type: DELETE_SENDER_ACCOUNT_SUCCESS,
  payload: id,
});

export const deleteSenderAccountFailure = (
  error: string
): DeleteSenderAccountFailureAction => ({
  type: DELETE_SENDER_ACCOUNT_FAILURE,
  payload: error,
});

export const clearSenderAccountState = (): ClearSenderAccountStateAction => ({
  type: CLEAR_SENDER_ACCOUNT_STATE,
});

export const getVerifiedSenderAccountsRequest =
  (): GetVerifiedSenderAccountsRequestAction => ({
    type: GET_VERIFIED_SENDER_ACCOUNTS_REQUEST,
  });

export const getVerifiedSenderAccountsSuccess = (
  senderAccounts: ISenderAccount[]
): GetVerifiedSenderAccountsSuccessAction => ({
  type: GET_VERIFIED_SENDER_ACCOUNTS_SUCCESS,
  payload: senderAccounts,
});

export const getVerifiedSenderAccountsFailure = (
  error: string
): GetVerifiedSenderAccountsFailureAction => ({
  type: GET_VERIFIED_SENDER_ACCOUNTS_FAILURE,
  payload: error,
});
